$(function() {
  return $("#ajax_ttlock_apis_users").click(function() {
    $("#ajax_ttlock_apis_users_results").append('<div class="ui active inverted dimmer"><div class="ui text loader">Loading</div></div>');
    var api_id = $("#api_id").text();
    alert(api_id);
    return $.ajax({
      url: '/ajax_ttlock_apis_users?id=' + api_id,
      type: 'get',
      dataType: 'json',
      async: true
    }).done(function(response) {
      $("#ajax_ttlock_apis_users_results").empty();
      var i, j, ref, results;
      $("#ajax_ttlock_apis_users_results").append("<tr><th>regtime</th><th>userid</th></tr>");
      user_results = response["list"];
      results = []
      for (i = j = 0, ref = user_results.length; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        results.push($("#ajax_ttlock_apis_users_results").append("<tr><td>" + user_results[i].regtime + "</td><td>" + user_results[i].userid + "</td></tr>"));
      }
      return results;
    }).fail(function(response) {
      return alert('fail');
    });
  });
});